import { connect } from "react-redux";
import { getAccessLevels, getInProgress } from "../accessLevels/redux/selectors";
import actionCreators from "../accessLevelsEditorPanel/redux/actionCreators";
import { getAccessLevelNew } from "../accessLevelsEditorPanel/redux/selectors";
import AccessLevelsCreatorPanel from "./accessLevelsCreatorPanel";
const mapStateToProps = (state, ownProps) => ({
    inProgress: getInProgress(state, ownProps.entityId, ownProps.entityType),
    data: getAccessLevels(state, ownProps.entityId, ownProps.entityType),
    accessLevelNew: getAccessLevelNew(state)
});
const mapDispatchToProps = (dispatch) => ({
    onClose: () => dispatch(actionCreators.setAccessLevelNew(undefined))
});
export default connect(mapStateToProps, mapDispatchToProps)(AccessLevelsCreatorPanel);
